import { RIGHT_DRAWER } from "@flexo/reducers";
import FeedbackPage from "../../feedback-page/feedback-page";
import { useDispatch } from "react-redux";
import { DrawerCloseButton } from '../drawer-close-button';
import { useTranslation } from 'react-i18next';
import styles from './right-drawer-content.module.scss';

export const FeedbackFormDrawerContent = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  function closeDrawer() {
    dispatch(RIGHT_DRAWER.HideDrawer());
  }

  return (
    <div style={{ position: 'relative' }}>
      <div className={styles.RightDrawerContent__Title__Custom}>
        <div>
          <p className={styles.RightDrawerContent__Paragraph}>{t('pages.profile.feedback.support')}</p>
          <DrawerCloseButton onClose={closeDrawer} ariaLabel={t('common.close', { defaultValue: 'Close' })} />
        </div>
        <p className={styles.RightDrawerContent__Title__Custom__Paragraph}>{t('pages.profile.feedback.subtitle')}</p>
        

      </div>
      <div className={styles.RightDrawerContent__Body__Custom}>

      <FeedbackPage {...{
            title: 'pages.profile.feedback.title',
            backgroundColor: '#f7f7f7',
            label_1: 'pages.profile.feedback.label_1',
            label_2: 'pages.profile.feedback.label_2',
            label_3: 'pages.profile.feedback.label_3',
            terms: 'pages.profile.feedback.terms',
            comment_label: 'pages.profile.feedback.comment_label',
            comment_description: 'pages.profile.feedback.comment_description',
            containedLabel: false,
            checkbox: true,
            checkbox_label: 'pages.profile.feedback.checkbox_label',
            confirmButton: 'pages.profile.feedback.confirmButton',
            buttonDescription: 'pages.profile.feedback.button_description',
            doneButton: 'pages.profile.feedback.doneButton',
            checkboxColor: 'midGrey',
      } as any} />
      </div>
    </div>
  );
};